<template>
  <div style="padding: 20px">
    <div>
<!--      <div class="page-title">-->
<!--        <a-breadcrumb separator-class="el-icon-arrow-right">-->
<!--          <a-breadcrumb-item :to="{ path: '/sell-plan' }">预售计划</a-breadcrumb-item>-->
<!--          <a-breadcrumb-item>预售计划商品-->
<!--          </a-breadcrumb-item>-->
<!--        </a-breadcrumb>-->
<!--      </div>-->
      <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
        <div></div>
        <a-button type="primary" @click="addSellPlanGoods">
          {{ $t('ADD') || '添加' }}
        </a-button>
      </div>
      <a-table
        row-key="id"
        :data-source="table.data"
        style="width: 100%">
        <a-table-column
          data-index="goods.name"
          title="商品"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="date"
          :title="$t('OPERATION') || '操作'">
          <template slot-scope="text, record">
            <a-button type="link" @click="editSellPlanGoods(record.id)">{{ $t('EDIT') || '编辑' }}
            </a-button>
            <a-button type="link" @click="deleteSellPlanGoods(record.id)">{{ $t('DELETE') || '删除' }}
            </a-button>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal
:footer="null"
      title="商品选择"
      append-to-body
      v-model="form.visible">
      <sellPlanGoods-edit
        v-if="form.visible"
        :sell-plan-goods-id="form.data.id"
        :sell-plan-id="sellPlanId"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </sellPlanGoods-edit>
    </a-modal>
  </div>
</template>

<script>
import {
  _querySellPlanGoodss,
  _deleteSellPlanGoods,
} from '@/api/sellPlanGoodsApi';
import SellPlanGoodsEdit from './SellPlanGoodsEdit.vue';

async function getSellPlanGoodsList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _querySellPlanGoodss({
    sellPlanId: this.sellPlanId,
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
}

function addSellPlanGoods() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editSellPlanGoods(sellPlanGoodsId) {
  this.form.data.id = sellPlanGoodsId;
  this.form.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getSellPlanGoodsList();
}

async function deleteSellPlanGoods(sellPlanGoodsId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      await _deleteSellPlanGoods(sellPlanGoodsId);
      this.$message.success('删除成功');
      this.getSellPlanGoodsList();
    },
  });
}

export default {
  name: 'SellPlanGoodsList',
  components: { SellPlanGoodsEdit },
  props: {
    sellPlanId: String,
  },
  data() {
    return {
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'id',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getSellPlanGoodsList,
    deleteSellPlanGoods,
    editSellPlanGoods,
    addSellPlanGoods,
    closeForm,
  },
  created() {
    this.getSellPlanGoodsList();
  },
};
</script>

<style scoped>

</style>
